<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="编辑检测项"></pt-page-title>
    <pt-sub-title title="检测项信息"></pt-sub-title>
    <pt-detection-form ref="child" @updateLoading="updateLoading" :isEdit="true" @upateCategory="upateCategory" @upateEngineDefault="upateEngineDefault"></pt-detection-form>
    <!-- 语料 -->
    <detection-corpus-collapse :id="id" :showEdit="true"></detection-corpus-collapse>
    <!-- 配置 -->
    <detection-config-collapse :id="id" :showButton="true" :category="detectionCategory" :detectionEngineDefault="detectionEngineDefault" @updateLoading="updateLoading"></detection-config-collapse>
    <div class="marginTop">
      <el-button type="primary" @click="edit">保存</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>

  </div>
</template>

<script>
// 组件class前缀
import detectionCorpusCollapse from 'cps/gene-product/selector/detection-corpus-collapse'
import detectionConfigCollapse from 'cps/gene-product/selector/detection-config-collapse'
import ptDetectionForm from '../pt-detection-form/withData'
const prefixCls = 'pt-detection-update'

export default {
  name: 'pt-detection-update',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      id: this.$route.params.id,
      loading: false,
      detectionCategory: this.$route.params.category,
      detectionEngineDefault: ''
    }
  },
  components: {
    detectionCorpusCollapse,
    detectionConfigCollapse,
    ptDetectionForm
  },
  methods: {
    updateLoading (val) {
      this.loading = val
    },
    upateCategory (val) {
      this.detectionCategory = val
    },
    upateEngineDefault (val) {
      this.detectionEngineDefault = val
    },
    edit () {
      this.$refs.child.edit()
    },
    cancel () {
      history.go(-1)
    }
  },
  created () {
    // this.getConfig()
    this.id = this.$route.params.id
    // 如果父组件没有传入产品数据，则本页面根据id进行获取
    // if (!this.detection) {
    //   this.load()
    // }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
